import { useSyncExternalStore } from 'react';

// The Encryption Password lives in memory only: never in storage, never in a URL or a log.
// It is dropped on logout and when the salary screen is left.
let passphrase = '';
const listeners = new Set();

const emit = () => listeners.forEach((l) => l());

export const getSalaryPassphrase = () => passphrase;
export const setSalaryPassphrase = (value) => { passphrase = value || ''; emit(); };
export const clearSalaryPassphrase = () => setSalaryPassphrase('');

export const useSalaryPassphrase = () => useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    getSalaryPassphrase,
);

// Axios config that carries the passphrase header (pass an override to verify a value before keeping it).
export const passphraseConfig = (override, extra = {}) => {
    const value = override ?? passphrase;
    return { ...extra, headers: { ...(extra.headers || {}), ...(value ? { 'X-Management-Passphrase': value } : {}) } };
};

// True when the server rejected the request over the Encryption Password (missing, wrong or locked out).
export const isPassphraseError = (err) => {
    const s = err?.response?.status;
    if (s === 401 || s === 423) return true;
    return s === 400 && /passphrase/i.test(err?.response?.data?.message || '');
};

// Words the user can act on for passphrase failures; null when the error is something else.
export const passphraseErrorText = (err) => {
    const s = err?.response?.status;
    const d = err?.response?.data;
    if (s === 423) {
        const until = d?.lockedUntil ? new Date(d.lockedUntil) : null;
        const when = until && !Number.isNaN(until.getTime()) ? ` Try again after ${until.toLocaleString()}.` : '';
        return `Too many incorrect attempts.${when}`;
    }
    if (s === 401) {
        const left = d?.attemptsRemaining;
        if (Number.isFinite(left)) {
            const n = Number(left);
            return `Incorrect password. ${n === 0 ? 'No attempts left.' : `${n} attempt${n === 1 ? '' : 's'} left before lockout.`}`;
        }
        return 'Incorrect password.';
    }
    if (s === 400 && /passphrase/i.test(d?.message || '')) return 'Enter the Encryption Password to continue.';
    return null;
};
